import { format } from "date-fns";
import { MfaSourceTypeEnum } from "../../common/enums/MfaSourceTypeEnum";
import { IeLynxUser } from "../../common/models/eLynxUser";
import { OfflineConfigSettings } from "../../services/offline-data-service/OfflineDataService";
import { DataTooltipDisplayEnum, IUserSettings, MarketingReportPreferenceSortDateEnum, TagHistoryViewEnum } from "../../services/user-settings-data/Models";
import i18next from "i18next";
import i18n from "../../services/localization-service/i18n";
import { UserRecipientFieldType } from "../user-recipient-list/UserRecipientFieldTypes";
import { IRecipient } from "../../common/models/IRecipient";
import { RecipientDisabledSourceEnum } from "../../common/enums/RecipientDisabledSourceEnum";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { IKeyValuePair } from "../../common/models/KeyValuePair";
import { GaugeSheetViewMode } from "../../views/gauge-sheet-view/GaugeSheetState";
import { FieldIsDirtyType } from "../../common/utility-types/FieldIsDirtyType";

export type AccountSettingsFormType = {

    email: string;
    phone: string;
    company: string;
    jobTitle: string;
    jobFunction: string;
    timezone: number;
    // Pull the MFA source from the user/user settings, but if it's not present,
    // and the customer has required MFA, then default the form to Email,
    // otherwise, default to Unconfigured
    mfaSource: MfaSourceTypeEnum;
    authenticationGuid: string;
    otp: string;

    recipients: UserRecipientFieldType[];

    pageSize: number;
    offlineMode: boolean;
    functionIcons: boolean;
    alarmsAtTop: boolean;
    outletsFirst: boolean;
    sortDates: MarketingReportPreferenceSortDateEnum;
    graphTooltip: DataTooltipDisplayEnum;
    graphsInViewPort: number;
    deviceView: boolean;
    tagView: TagHistoryViewEnum;
    theme: string;

    collapseTagGroups: number;

    defaultDeviceView: UIViewEnum;
    defaultGroupView: UIViewEnum;
    gridFontSize: number;
    gridCellPadding: number;


    gaugeSheetViewMode: GaugeSheetViewMode;
    gaugeSheetShowDevice: boolean;
    gaugeSheetShowTanks: boolean;
}


function getDefaultMfaSource (user: IeLynxUser, userSettings: IUserSettings) {

    let source = user.mfaSource ?? userSettings?.mfaSource ?? MfaSourceTypeEnum.Unconfigured;

    if (userSettings.mfaRequired && source === MfaSourceTypeEnum.Unconfigured) {
        source = MfaSourceTypeEnum.Email;
    }
    return source;
}


export const defaultAccountSettings: AccountSettingsFormType = {

        email: '',
        phone: '',
        company: '',
        jobTitle: '',
        jobFunction: '',
        timezone: 20,
        mfaSource: MfaSourceTypeEnum.Email,
        authenticationGuid: '',
        otp: '',
        recipients: [],

        pageSize: 50,
        offlineMode: false,
        functionIcons: true,
        alarmsAtTop: true,
        outletsFirst: false,
        sortDates: MarketingReportPreferenceSortDateEnum.LeftToRight,
        graphTooltip: DataTooltipDisplayEnum.Shared,
        graphsInViewPort: 2,
        deviceView: true,
        tagView: TagHistoryViewEnum.Chart,
        theme: 'light',
        collapseTagGroups: 0,
        defaultDeviceView: UIViewEnum.Device_Details,
        defaultGroupView: UIViewEnum.Group_SummaryListing,
        gridFontSize: 13,
        gridCellPadding: 5,
        gaugeSheetViewMode: GaugeSheetViewMode.Spreadsheet,
        gaugeSheetShowDevice: true,
        gaugeSheetShowTanks: true,

}

export const jobFunctions: string[] = [
    i18n.t('profile.jobFunctions.admin'),
    i18n.t('profile.jobFunctions.assetManager'),
    i18n.t('profile.jobFunctions.eng'),
    i18n.t('profile.jobFunctions.engmanager'),
    i18n.t('profile.jobFunctions.investor'),
    i18n.t('profile.jobFunctions.it'),
    i18n.t('profile.jobFunctions.marketer'),
    i18n.t('profile.jobFunctions.opsmanager'),
    i18n.t('profile.jobFunctions.other'),
    i18n.t('profile.jobFunctions.prodForeman'),
    i18n.t('profile.jobFunctions.pumper'),
    i18n.t('profile.jobFunctions.workSuper')
];

export const groupViews: IKeyValuePair<string, UIViewEnum>[] = [
    { Key: i18n.t('views.customForms'), Value: UIViewEnum.Group_CustomForm},
    { Key: i18n.t('views.groupGraph'), Value: UIViewEnum.Group_Graph },
    { Key: i18n.t('views.imageView'), Value: UIViewEnum.Group_HMIView },
    { Key: i18n.t('views.map'), Value: UIViewEnum.Group_MapView },
    { Key: i18n.t('views.reporting'), Value: UIViewEnum.Group_Reporting },
    { Key: i18n.t('views.summaryListing'), Value: UIViewEnum.Group_SummaryListing },
];


export const deviceViews: IKeyValuePair<string, UIViewEnum>[] = [
    //{ Key: i18n.t('views.dashboard'), Value: UIViewEnum.Device_Dashboard },
    { Key: i18n.t('views.deviceDetails'), Value: UIViewEnum.Device_Details },
    { Key: i18n.t('views.deviceGraph'), Value: UIViewEnum.Device_Graph },
    { Key: i18n.t('views.customForms'), Value: UIViewEnum.Device_CustomForm },
    { Key: i18n.t('views.imageView'), Value: UIViewEnum.Device_HMIView },
];


// type RecipientsDirtyFieldsType = Partial<Readonly<{
//     disabled?: boolean | undefined;
// }>>

export type DirtyFieldsType = FieldIsDirtyType<AccountSettingsFormType>;
// export type DirtyFieldsType = Partial<Readonly< {
//     email?: boolean | undefined;
//     phone?: boolean | undefined;
//     company?: boolean | undefined;
//     jobTitle?: boolean | undefined;
//     jobFunction?: boolean | undefined;
//     timezone?: boolean | undefined;
//     mfaSource?: boolean | undefined;
//     authenticationGuid?: boolean | undefined;
//     otp?: boolean | undefined;
//     recipients?: RecipientsDirtyFieldsType[];

//     pageSize?: boolean | undefined;
//     offlineMode?: boolean | undefined;
//     functionIcons?: boolean | undefined;
//     alarmsAtTop?: boolean | undefined;
//     outletsFirst?: boolean | undefined;
//     sortDates?: boolean | undefined;
//     graphTooltip?: boolean | undefined;
//     graphsInViewPort?: boolean | undefined;
//     deviceView?: boolean | undefined;
//     tagView?: boolean | undefined;
//     theme?: boolean | undefined;

//     collapseTagGroups?: boolean | undefined;

//     defaultDeviceView?: boolean | undefined;
//     defaultGroupView?: boolean | undefined;

//     gridFontSize?: boolean | undefined;
//     gridCellPadding?: boolean | undefined;

//     gaugeSheetViewMode?: boolean | undefined;
//     gaugeSheetShowDevice?: boolean | undefined;
//     gaugeSheetShowTanks?: boolean | undefined;
// }>>;

const AccountSettingUtils = {

    mapToForm: function(
        user: IeLynxUser,
        userSettings: IUserSettings | undefined,
        userRecipients: IRecipient[] | undefined,
        offlineConfig: OfflineConfigSettings,
        defaultDeviceView: UIViewEnum,
        defaultGroupView: UIViewEnum,
        //offline: boolean,
        ): AccountSettingsFormType {

        const form: AccountSettingsFormType = {


            email: user.contactEmail ?? '',
            phone: user.phoneNumber ?? '',
            company: user.companyName ?? '',
            jobTitle: user.jobTitle ?? '',
            jobFunction: user.jobFunction ?? '',
            timezone: user.timeZoneIndex ?? 20,
            // Pull the MFA source from the user/user settings, but if it's not present,
            // and the customer has required MFA, then default the form to Email,
            // otherwise, default to Unconfigured
            mfaSource: userSettings ? getDefaultMfaSource(user, userSettings) : MfaSourceTypeEnum.Email,
            authenticationGuid: userSettings ? userSettings.authenticationGuid ?? '' : '',
            otp: '',
            recipients: userRecipients ? userRecipients.map((o => {
                return {
                    id: o.id,
                    type: o.recipientType,
                    subType: o.recipientSubType,
                    to: o.to,
                    disabled: o.disabled,
                    disabledTimestamp: o.disabledTimestamp,
                    usageCount: undefined,
                    cloneRecipientID: undefined
                    } as UserRecipientFieldType
            })) : [],
    
            pageSize: userSettings ? userSettings.gridRowCount : 0,
            offlineMode: offlineConfig.enabled ?? false,
            functionIcons: userSettings ? userSettings.summaryListingDisplayFunctionIcons : false,
            alarmsAtTop: userSettings ? userSettings.summaryListingAlarmAtTop : false,
            outletsFirst: userSettings ? userSettings.summaryListingOutletsFirst : false,
            sortDates: userSettings ? userSettings.marketingReportSortDate : MarketingReportPreferenceSortDateEnum.LeftToRight,
            graphTooltip: userSettings ? userSettings.trendingDataTooltipDisplay : DataTooltipDisplayEnum.Separate,
            graphsInViewPort: userSettings ? userSettings.trendingNumberChartsInViewport : 1,
            deviceView: userSettings ? userSettings.defaultDeviceView : false,
            tagView: userSettings ? userSettings.tagHistoryView : TagHistoryViewEnum.Grid,
            theme: userSettings ? userSettings.theme ?? 'light' : 'light',
            collapseTagGroups: userSettings ? userSettings.collapseTagGroups ? 1 : 0 : 0,
            defaultDeviceView: defaultDeviceView,
            defaultGroupView: defaultGroupView,

            gridFontSize: userSettings?.gridFontSize ?? 13,
            gridCellPadding: userSettings?.gridCellPadding ?? 5,

            gaugeSheetViewMode: userSettings?.gaugeSheetViewMode ?? GaugeSheetViewMode.Spreadsheet,
            gaugeSheetShowDevice: userSettings?.gaugeSheetShowDevice ?? true,
            gaugeSheetShowTanks: userSettings?.gaugeSheetShowTanks ?? true
        }

        return form;
    },
    getOtpLastVerifiedText: function (value: string | undefined): string  {
        const timestamp = value
            ? format(new Date(value), "P pp")
            : "";

        return i18next.t("profile.otpLastVerified", {
            timestamp: timestamp
        });
    },
    hasProfileChanges: function(dirtyFields: DirtyFieldsType): boolean {

        return ((dirtyFields?.email ?? false) ||
        (dirtyFields?.phone ?? false) ||
        (dirtyFields?.company ?? false) ||
        (dirtyFields?.jobTitle ?? false) ||
        (dirtyFields?.jobFunction ?? false) ||
        (dirtyFields?.timezone ?? false) ||
        (dirtyFields?.mfaSource ?? false) ||
        (dirtyFields?.authenticationGuid ?? false) ||
        (dirtyFields?.otp ?? false)
         ||
        (dirtyFields?.recipients ? 
            dirtyFields?.recipients.map(o => (o?.disabled ?? false))
                .find(o => o === true) !== undefined : 
            false
        ));
    },
    
    hasPreferenceChanges: function(dirtyFields: DirtyFieldsType): boolean {

        return ((dirtyFields?.pageSize ?? false) ||
        (dirtyFields?.offlineMode ?? false) ||
        (dirtyFields?.functionIcons ?? false) ||
        (dirtyFields?.alarmsAtTop ?? false) ||
        (dirtyFields?.outletsFirst ?? false) ||
        (dirtyFields?.sortDates ?? false) ||
        (dirtyFields?.graphTooltip ?? false) ||
        (dirtyFields?.graphsInViewPort ?? false) ||
        (dirtyFields?.deviceView ?? false) ||
        (dirtyFields?.tagView ?? false) ||
        (dirtyFields?.theme ?? false)) ||
        ((dirtyFields?.collapseTagGroups ?? false)) ||
        ((dirtyFields?.defaultDeviceView ?? false)) ||
        ((dirtyFields?.defaultGroupView ?? false)) ||
        (dirtyFields?.gridFontSize ?? false) ||
        (dirtyFields?.gridCellPadding ?? false) ||
        (dirtyFields?.gaugeSheetViewMode ?? false) ||
        (dirtyFields?.gaugeSheetShowDevice ?? false) ||
        (dirtyFields?.gaugeSheetShowTanks ?? false);
    },
    mapToProfileModel: function(form: AccountSettingsFormType, user: IeLynxUser, userRecipients: IRecipient[]): IeLynxUser {

        const phoneNumber = form.phone.replace(/-/g, '')?.trim();

        const entity: IeLynxUser =
        {
            ...user,
            baseGroup: user.baseGroup,
            contactEmail: form.email as string,
            phoneNumber: phoneNumber?.length
                ? form.phone?.trim()
                : undefined,
            companyName: form.company,
            jobTitle: form.jobTitle,
            jobFunction: form.jobFunction,
            timeZoneIndex: form.timezone,
            mfaSource: form.mfaSource ?? MfaSourceTypeEnum.Unconfigured,
            authenticationGuid: form?.authenticationGuid ?? "",
            recipients: []
        };

        userRecipients.forEach(o => {

            const updatedRecipient = {...o,
            } as IRecipient;
            const formRecipient = form.recipients.find(v => v.id === o.id);
            if (formRecipient) {
                updatedRecipient.disabled = formRecipient.disabled;
                updatedRecipient.to = formRecipient.to;
                updatedRecipient.disabledSource = formRecipient.disabled ? 
                                                    RecipientDisabledSourceEnum.EditUser : 
                                                    undefined;
                updatedRecipient.disabledBy = formRecipient.disabled ? 
                                                    user.id : 
                                                    undefined;
            }
            entity.recipients?.push(updatedRecipient);
        });

        return entity;        
    },
    mapToPreferencesModel: function(form: AccountSettingsFormType, userSettings: IUserSettings): IUserSettings {

        const settings: IUserSettings = {
            ...userSettings,
            gridRowCount: form.pageSize,
            summaryListingDisplayFunctionIcons: form.functionIcons,
            summaryListingAlarmAtTop: form.alarmsAtTop,
            summaryListingOutletsFirst: form.outletsFirst,
            marketingReportSortDate: form.sortDates,
            trendingDataTooltipDisplay: form.graphTooltip,
            trendingNumberChartsInViewport: form.graphsInViewPort,
            defaultDeviceView: form.deviceView,
            tagHistoryView: form.tagView,
            theme: form.theme,
            collapseTagGroups: form.collapseTagGroups === 1,
            gridFontSize: form.gridFontSize,
            gridCellPadding: form.gridCellPadding,  
            gaugeSheetViewMode: form.gaugeSheetViewMode,
            gaugeSheetShowDevice: form.gaugeSheetShowDevice,
            gaugeSheetShowTanks: form.gaugeSheetShowTanks

        };

        return settings;
    }
}

export default AccountSettingUtils;